


























import { defineComponent, onMounted, reactive } from '@vue/composition-api'
import moment from 'moment'

import { NoticeState, UserState } from '@/types/store'
import useVuex from '@/utils/useVuex'
import { UserRole } from '@/types/user'

export default defineComponent({
  name: 'NewsBoard',
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      notices: useVuex<NoticeState['notices']>(
        context,
        () => store.getters['notice/notices'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })

    onMounted(() => {
      store.dispatch('notice/getNotices', {
        distributeFor: state.user?.role || UserRole.LINKER,
        isValid: true,
      })
    })

    const formatDate = (date: Date) => {
      return moment(date).format('YYYY/MM/DD HH:mm')
    }

    return { state, formatDate }
  },
})
